import type { Editor } from '@tiptap/core';
import { FindReplace } from '@/editor/findReplace';
import { icon } from '@/icons/icons';

// ═══════════════════════════════════════════════════════════════
// Panel Najít a nahradit (sekce 2.1). Vlastní UI v aplikaci, ne
// prohlížečové vyhledávání. Ctrl+F otevře v režimu Najít, Ctrl+H v
// režimu Nahradit.
// ═══════════════════════════════════════════════════════════════

export class FindPanel {
  private root: HTMLElement;
  private fr: FindReplace;
  private findInput!: HTMLInputElement;
  private replaceInput!: HTMLInputElement;
  private counter!: HTMLElement;
  private replaceRow!: HTMLElement;
  private visible = false;

  constructor(mount: HTMLElement, private editor: Editor) {
    this.fr = new FindReplace(editor);
    this.root = document.createElement('div');
    this.root.className = 'find-panel hidden';
    this.build();
    mount.appendChild(this.root);
  }

  private build() {
    this.root.innerHTML = `
      <div class="find-panel-inner">
        <div class="find-row">
          <input type="text" class="find-input" placeholder="Najít" />
          <span class="find-counter">0/0</span>
          <button class="find-nav" data-act="prev" title="Předchozí">▲</button>
          <button class="find-nav" data-act="next" title="Další">▼</button>
          <button class="find-close" title="Zavřít (Esc)">${icon('close', 16)}</button>
        </div>
        <div class="replace-row">
          <input type="text" class="replace-input" placeholder="Nahradit čím" />
          <button class="find-btn" data-act="replace">Nahradit</button>
          <button class="find-btn" data-act="replaceAll">Vše</button>
        </div>
      </div>`;

    this.findInput = this.root.querySelector('.find-input')!;
    this.replaceInput = this.root.querySelector('.replace-input')!;
    this.counter = this.root.querySelector('.find-counter')!;
    this.replaceRow = this.root.querySelector('.replace-row')!;

    this.findInput.addEventListener('input', () => this.runFind());
    this.findInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); e.shiftKey ? this.fr.prev() : this.fr.next(); this.updateCounter(); }
      if (e.key === 'Escape') this.hide();
    });

    this.root.querySelector('[data-act="prev"]')!.addEventListener('click', () => { this.fr.prev(); this.updateCounter(); });
    this.root.querySelector('[data-act="next"]')!.addEventListener('click', () => { this.fr.next(); this.updateCounter(); });
    this.root.querySelector('.find-close')!.addEventListener('click', () => this.hide());
    this.root.querySelector('[data-act="replace"]')!.addEventListener('click', () => { this.fr.replace(this.replaceInput.value); this.updateCounter(); });
    this.root.querySelector('[data-act="replaceAll"]')!.addEventListener('click', () => { this.fr.replaceAll(this.replaceInput.value); this.updateCounter(); });
  }

  private runFind() {
    this.fr.find(this.findInput.value);
    this.updateCounter();
  }

  private updateCounter() {
    const n = this.fr.count();
    const i = this.fr.currentIndex();
    this.counter.textContent = n ? `${i + 1}/${n}` : '0/0';
  }

  show(mode: 'find' | 'replace') {
    this.visible = true;
    this.root.classList.remove('hidden');
    this.replaceRow.style.display = mode === 'replace' ? 'flex' : 'none';
    // Přednaplň výběrem, pokud něco je vybráno.
    const { from, to } = this.editor.state.selection;
    if (from !== to) {
      this.findInput.value = this.editor.state.doc.textBetween(from, to, ' ');
      this.runFind();
    }
    this.findInput.focus();
    this.findInput.select();
  }

  hide() {
    this.visible = false;
    this.root.classList.add('hidden');
    this.fr.reset();
    this.editor.commands.focus();
  }

  toggle(mode: 'find' | 'replace') {
    if (this.visible && this.replaceRow.style.display !== 'none' && mode === 'replace') { this.hide(); return; }
    this.show(mode);
  }
}
